module.exports = __webpack_public_path__ + "img/pic_under_review.93d3d18c.png";